import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Check, Loader2, AlertCircle } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | failed | timeout
  const [details, setDetails] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setState("failed");
      return;
    }
    let attempts = 0;
    const maxAttempts = 10;
    const poll = async () => {
      try {
        const res = await api.get(`/checkout/status/${sessionId}`);
        setDetails(res.data);
        if (res.data.payment_status === "paid") {
          setState("paid");
          return;
        }
        if (res.data.status === "expired") {
          setState("failed");
          return;
        }
        attempts += 1;
        if (attempts >= maxAttempts) {
          setState("timeout");
          return;
        }
        setTimeout(poll, 2000);
      } catch {
        setState("failed");
      }
    };
    poll();
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page" className="max-w-2xl mx-auto px-6 py-24">
      <div className="rm-card p-10 text-center">
        {state === "checking" && (
          <>
            <Loader2 size={48} className="animate-spin mx-auto text-[#1f3a8a]" />
            <h1 className="font-display text-3xl font-bold text-[#0f172a] mt-6">Sprawdzamy płatność...</h1>
            <p className="text-slate-500 mt-2">To zajmie kilka sekund.</p>
          </>
        )}
        {state === "paid" && (
          <>
            <div className="w-16 h-16 rounded-full bg-green-100 mx-auto flex items-center justify-center">
              <Check size={32} className="text-green-600" strokeWidth={3} />
            </div>
            <h1 className="font-display text-3xl font-bold text-[#0f172a] mt-6">Dziękujemy za płatność!</h1>
            <p className="text-slate-600 mt-3">
              Twoje zamówienie zostało opłacone. Karta SIM dotrze w 2–3 dni robocze.
            </p>
            {details && (
              <p className="text-sm text-slate-400 mt-4">
                Kwota: {(details.amount_total / 100).toFixed(2)} {details.currency?.toUpperCase()}
              </p>
            )}
            <Link to="/" className="rm-btn-primary inline-block mt-8">Wróć na stronę główną</Link>
          </>
        )}
        {state === "timeout" && (
          <>
            <AlertCircle size={48} className="mx-auto text-amber-500" />
            <h1 className="font-display text-3xl font-bold text-[#0f172a] mt-6">Płatność jest przetwarzana</h1>
            <p className="text-slate-600 mt-3">
              Status płatności potwierdzimy mailem w ciągu kilku minut. Możesz bezpiecznie zamknąć tę stronę.
            </p>
            <Link to="/" className="rm-btn-primary inline-block mt-8">Wróć na stronę główną</Link>
          </>
        )}
        {state === "failed" && (
          <>
            <AlertCircle size={48} className="mx-auto text-red-500" />
            <h1 className="font-display text-3xl font-bold text-[#0f172a] mt-6">Nie udało się zweryfikować płatności</h1>
            <p className="text-slate-600 mt-3">Skontaktuj się z nami, jeśli środki zostały pobrane.</p>
            <Link to="/kontakt" className="rm-btn-primary inline-block mt-8">Kontakt</Link>
          </>
        )}
      </div>
    </div>
  );
}
